import React from "react"
import { Flex, Heading, Text, Box } from "@chakra-ui/react"

import { StaticImage } from "gatsby-plugin-image"

const styles = {
  root: {
    width: "100%",
    px: { base: "16px", md: "24px", lg: "24px" },
    mt: "24px",
  },
  "inner-box": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  "main-heading": {
    fontFamily: "Inter var, sans-serif",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
  },
  "sub-text": {
    fontFamily: "Inter var, sans-serif",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#595C5F",
    fontWeight: 400,
  },
}

const EmptyState = () => {
  return (
    <Box sx={styles.root}>
      <Flex sx={styles["inner-box"]}>
        <StaticImage
          src="../../../images/empty-state/empty-state.png"
          alt="Avant-garde Health EmptyState"
          placeholder="blurred"
        />
        <Heading as="h1" sx={styles["main-heading"]}>
          Unfortunately, nothing was found
        </Heading>
        <Text as="h1" sx={styles["sub-text"]}>
          Try different filters with different keywords.
        </Text>
      </Flex>
    </Box>
  )
}

export default EmptyState
